import React from 'react';
import { Sparkles } from 'lucide-react';

interface SuggestedQuestionsProps {
  onSelect: (question: string) => void;
  disabled?: boolean;
}

const SUGGESTIONS = [
  'Qual o faturamento total do mês?',
  'Quantos pedidos foram aprovados hoje?',
  'Top 10 lojistas por volume de vendas',
  'Resumo de vendas por categoria',
  'Pedidos cancelados na última semana',
  'Quais os produtos mais vendidos?',
];

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({ onSelect, disabled }) => (
  <div className="px-6 py-4">
    <div className="flex items-center gap-2 mb-3">
      <Sparkles className="w-4 h-4 text-amber-500" />
      <span className="text-sm font-medium text-gray-600">Sugestões de perguntas</span>
    </div>
    <div className="flex flex-wrap gap-2">
      {SUGGESTIONS.map((suggestion, idx) => (
        <button
          key={idx}
          onClick={() => !disabled && onSelect(suggestion)}
          disabled={disabled}
          className="px-3 py-1.5 text-xs font-medium rounded-full border border-gray-200 bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-700 hover:border-blue-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {suggestion}
        </button>
      ))}
    </div>
  </div>
);

export default SuggestedQuestions;
